import { PageHeader } from '@/components/primitives/PageHeader'
import { cn } from '@/lib/utils'
import { motion } from 'framer-motion'
import { NavLink, Outlet, useLocation } from 'react-router-dom'

const TABS = [
  { id: 'overview', label: 'Overview', to: '/dashboard' },
  { id: 'analytics', label: 'Analytics', to: '/dashboard/analytics' },
  { id: 'ai', label: 'AI', to: '/dashboard/ai' },
  { id: 'scrapers', label: 'Scrapers', to: '/dashboard/scrapers' },
  { id: 'finance', label: 'Finance', to: '/dashboard/finance' },
  { id: 'system', label: 'System', to: '/dashboard/system' }
]

export function DashboardLayout() {
  const location = useLocation()

  return (
    <div className="space-y-4">
      <PageHeader
        title="Dashboard"
        description="All the numbers at a glance — every tile is live, every chart updates without a reload."
      />

      <div className="relative flex gap-1 border-b">
        {TABS.map((tab) => {
          const active =
            tab.to === '/dashboard'
              ? location.pathname === '/dashboard'
              : location.pathname.startsWith(tab.to)
          return (
            <NavLink
              key={tab.id}
              to={tab.to}
              end={tab.to === '/dashboard'}
              className={cn(
                'relative px-4 py-2 text-sm transition-colors',
                active
                  ? 'text-foreground'
                  : 'text-muted-foreground hover:text-foreground'
              )}
            >
              {tab.label}
              {active && (
                <motion.div
                  layoutId="dashboard-tab-indicator"
                  className="absolute inset-x-0 -bottom-px h-0.5 bg-primary"
                  transition={{ type: 'spring', stiffness: 380, damping: 30 }}
                />
              )}
            </NavLink>
          )
        })}
      </div>

      <Outlet />
    </div>
  )
}
